export const BASE_URL = 'https://pokeapi.co/api/v2';

export const CACHE_AGE_IN_MINUTES = 15;

export const GET_POKEMON_LIST_LIMIT = 20;

export enum E_API_PATH {
  GET_POKEMON_LIST = '/pokemon',
  GET_POKEMON_SPECIES = '/pokemon-species',
  GET_POKEMON_EVOLUTION = '/evolution-chain',
}